import { NavLink, Outlet } from 'react-router-dom';
import { CHAIN_ID, EXPLORER_BASE, TOKEN_AGGREGATION_BASE } from '@/config';

const linkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export function Layout() {
  return (
    <div className="layout">
      <header className="site">
        <div className="brand">
          info.defi-oracle.io
          <span> — Chain {CHAIN_ID}</span>
        </div>
        <nav className="site">
          <NavLink to="/" end className={linkClass}>
            Overview
          </NavLink>
          <NavLink to="/tokens" className={linkClass}>
            c* &amp; cW*
          </NavLink>
          <NavLink to="/pools" className={linkClass}>
            Pools
          </NavLink>
          <NavLink to="/swap" className={linkClass}>
            Swap
          </NavLink>
          <NavLink to="/routing" className={linkClass}>
            Routing
          </NavLink>
        </nav>
      </header>
      <Outlet />
      <footer className="site">
        <p>
          Live data from token-aggregation API:{' '}
          <span className="mono">{TOKEN_AGGREGATION_BASE}</span>
          <br />
          Explorer:{' '}
          <a href={EXPLORER_BASE} target="_blank" rel="noreferrer">
            {EXPLORER_BASE}
          </a>
          {' · '}
          Repo docs:{' '}
          <span className="mono">docs/04-configuration/DEX_AND_AGGREGATORS_CHAIN138_EXPLAINER.md</span>,{' '}
          <span className="mono">docs/11-references/CW_STAR_CMC_COINGECKO_LISTING_STATUS.md</span>
        </p>
      </footer>
    </div>
  );
}
